export const withPreventDefault = <T>(fn: () => T) => (e: React.FormEvent): T => {
  e.preventDefault();
  return fn();
};
